// ** React Imports
import { useState } from 'react'

// ** Reactstrap Imports
import { TabContent, TabPane, Nav, NavItem, Row, Col, Button } from 'reactstrap'
import { FaCirclePlus } from "react-icons/fa6";
import { ButtonText, CardButtons, LiveOrgPrice, ProdCardName } from '../../../../StyledComponents';
import card from '../../../../assets/images/UserPayment/card.svg'
import maelano from '../../../../assets/icons/MaelanoIcon.png'
import GiftCard from './GiftCard';
import ProductVoucher from './ProductVoucher';

const MaelanowalletInfo = ({ setShowAddBalanceForm, setShowMaelanoActivity }) => {
  // ** State
  const [active, setActive] = useState('0')

  const toggle = tab => {
    if (active !== tab) {
      setActive(tab)
    }
  }

  const handleSwitchTab = () => {
    setActive('0');
  };

  return (
    <div className='nav-vertical'>
        
      <Nav tabs className='nav-left' style={{ borderRadius: '0', borderRight: '1px solid #d9d9d9', borderBottom:'none' }}>
        <ButtonText style={{ color: 'black', padding: '0.5rem' }}>Maelano Card</ButtonText>
        <NavItem className={`custom-credit-cards ${active === '0' ? 'active' : ''}`} onClick={() => toggle('0')}>
          <div className='w-100'>
            <Row className='align-items-center'>
              <Col lg='6' xl='6'>
                <div style={{ backgroundColor: '#D9D9D9', padding: '0.5rem', display: 'flex', justifyContent: 'center' }}>
                  <img src={maelano} />
                </div>
              </Col>
              <Col lg='6' xl='6'>
                <ProdCardName>Maelano Card</ProdCardName>
                <ProdCardName>Balance 0.0$</ProdCardName>
              </Col>
            </Row>
          </div>
        </NavItem>
        <ButtonText style={{ color: 'black', padding: '0.5rem' }}>Rewards/Gifts</ButtonText>

        <NavItem className={`custom-credit-cards ${active === '1' ? 'active' : ''}`} onClick={() => toggle('1')}>
          <div className='w-100'>
            <Row className='align-items-center'>
              <Col lg='4' xl='4'>
                <div style={{ backgroundColor: '#D9D9D9', padding: '0.5rem', display: 'flex', justifyContent: 'center' }}>
                  <FaCirclePlus size={34} />
                </div>
              </Col>
              <Col lg='8' xl='8'><ProdCardName>Gift Card</ProdCardName></Col>
            </Row>
          </div>
        </NavItem>
        <NavItem className={`custom-credit-cards ${active === '2' ? 'active' : ''}`} onClick={() => toggle('2')}>
          <div className='w-100'>
            <Row className='align-items-center'>
              <Col lg='4' xl='4'>
                <div style={{ backgroundColor: '#D9D9D9', padding: '0.5rem', display: 'flex', justifyContent: 'center' }}>
                  <FaCirclePlus size={34} />
                </div>
              </Col>
              <Col lg='8' xl='8'><ProdCardName>Product Voucher</ProdCardName></Col>
            </Row>
          </div>
        </NavItem>
        
      </Nav>

      <TabContent activeTab={active}>

        <TabPane tabId='0'>
          
                <ButtonText style={{ color: 'black', padding: '0.5rem', fontWeight: '500' }}>Maelano Card</ButtonText>
          <Row className='w-100'>
            <Col xl='12' lg='12' md='12' sm='12' xs='12'>
              <div>
                <div className='custom-card' style={{width:'auto', alignItems:'unset'}} >
                  <div>
                    <div style={{display:'flex', flexDirection:'row', alignItems:'center', flexWrap:'wrap',}} >
                    <div className='custom-tab' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '200px' }}>
                        <div >
                          <img src={maelano} />
                        </div>
                    </div>
                    <div style={{display:'flex', flexDirection:'column', justifyContent:'space-around', height:'102px'}}>
                        <button type='button' className='btn' style={{ background: 'transparent', color: 'black', border:'1px solid #d9d9d9', height:'41px', width:'167px' }} onClick={() => setShowMaelanoActivity(true)}>View Activity</button>
                        <button type='button' className='btn' style={{ background: 'transparent', color: 'black', border:'1px solid #d9d9d9', height:'41px', width:'167px' }} onClick={() => setShowAddBalanceForm(true)}>Reload Balance</button>
                    </div>
                    </div>
                    <div className='px-2'>
                        <div>Maelano Card</div>
                        <div>Balance 0.0$</div>
                    </div>
                  </div>
                  
                  
                </div>
              </div>
            </Col>
          </Row>
         
        </TabPane>
        <TabPane tabId='1'>
          {active === '1' && <GiftCard onSwitchTab={handleSwitchTab} />}
        </TabPane>
        <TabPane tabId='2'>
          {active === '2' && <ProductVoucher onSwitchTab={handleSwitchTab} />}
        </TabPane>
        <TabPane tabId='3'>
          {/* {active === '3' && <AddPayPal onSwitchTab={handleSwitchTab} />} */}
        </TabPane>
      </TabContent>
    </div>
  )
}

export default MaelanowalletInfo;
